import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import Theme from 'Theme';

const defaultStyles = {
    holder: {
        width: '100%',
        height: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: 0
    },
    indicator: {
        width: 0.2,
        height: '100%',
        backgroundColor: Theme.primaryActiveColor,
        borderRadius: 0
    }
};

const LineIndicator = ({ progress, style, color }) => {
    const width = `${progress > 100 ? 100 : progress}%`;
    return (
        <View style={[defaultStyles.holder, style]}>
            <View
                style={[defaultStyles.indicator, { width }, color && { backgroundColor: color }]}
            />
        </View>
    );
};

LineIndicator.defaultProps = {
    style: null,
    color: null
};

LineIndicator.propTypes = {
    progress: PropTypes.number.isRequired,
    style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
    color: PropTypes.string
};

export default LineIndicator;
